import { createSlice } from "@reduxjs/toolkit";

export const apiErrorSlice = createSlice({
  name: "apiError",
  initialState: {
    error: null,
    unauthorised: null,
  },
  reducers: {
    setApiError: (state, action) => {
      state.error = action.payload;
    },
    // Called once the layout has handled an unauthorised error, so the next one re-triggers it.
    resetUnauthorised: (state) => {
      state.unauthorised = null;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      (action) => action.type.endsWith("/rejected"),
      (state, action) => {
        state.error = action.error.message;
        // The backend rejects a shopper token that belongs to an older checkout session
        // (or has expired) with this message, not always with a 401.
        const isInvalidShopperToken = /invalid shopper access token/i.test(
          action?.payload?.data?.message || ""
        );
        if (
          action?.payload?.status === 401 ||
          action?.error?.message?.includes("401") ||
          isInvalidShopperToken
        ) {
          state.unauthorised = true;
        }
      }
    );
  },
});

export const { setApiError, resetUnauthorised } = apiErrorSlice.actions;

export const selectApiError = (state) => state.apiError.error;
export const selectUnauthorised = (state) => state.apiError.unauthorised;

export default apiErrorSlice.reducer;
